module.exports = __webpack_public_path__ + "static/media/image01.200ad05e.png";